
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1126"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1126"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9DUBZ", function(module, exports) {

$parcel$export(module.exports, "typeWriter", () => $01cfcd1698ded080$export$245947e8fe008c97);
function $01cfcd1698ded080$export$245947e8fe008c97(element, text, speed = 100) {
    let i = 0;
    function type() {
        if (i < text.length) {
            element.innerHTML += text.charAt(i);
            i++;
            setTimeout(type, speed);
        }
    }
    type();
}

});


var $9DUBZ = parcelRequire("9DUBZ");
document.addEventListener("DOMContentLoaded", ()=>{
    // --- From Pseudo File: Initialize Animations & Particles ---
    const typingHeading = document.getElementById("typing-heading");
    if (typingHeading) (0, $9DUBZ.typeWriter)(typingHeading, "Get in Touch");
    if (typeof tsParticles !== "undefined") tsParticles.load("tsparticles", {
        fpsLimit: 60,
        interactivity: {
            events: {
                onHover: {
                    enable: true,
                    mode: "repulse"
                },
                resize: true
            },
            modes: {
                repulse: {
                    distance: 100,
                    duration: 0.4
                }
            }
        },
        particles: {
            color: {
                value: [
                    "#066fff",
                    "#a020f0",
                    "#404040"
                ]
            },
            links: {
                color: "#404040",
                distance: 160,
                enable: true,
                opacity: 0.65,
                width: 1.2
            },
            collisions: {
                enable: true
            },
            move: {
                direction: "none",
                enable: true,
                outModes: {
                    default: "bounce"
                },
                random: false,
                speed: 1.2,
                straight: false
            },
            number: {
                density: {
                    enable: true,
                    area: 800
                },
                value: 100
            },
            opacity: {
                value: 0.65
            },
            shape: {
                type: "circle"
            },
            size: {
                value: {
                    min: 1,
                    max: 7
                }
            }
        },
        detectRetina: true
    });
    const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const el = entry.target;
                const animation = el.getAttribute("data-animation");
                const delay = parseInt(el.getAttribute("data-delay")) || 0;
                setTimeout(()=>{
                    el.classList.add(animation, "animated");
                }, delay);
            }
        });
    }, observerOptions);
    document.querySelectorAll("[data-animation]").forEach((el)=>observer.observe(el));
});


//# sourceMappingURL=contact.5d546d44.js.map
